import { GD } from "./GD";
import { hasAnyRole, ProjectRole } from "./permissions";

export type TAvailableFeatures =
	| "sessions"
	| "overview"
	| "credentials"
	| "settings"
	| "integrations"
	| "fees"
	| "client_users"
	| "client_overview"
	| "client_summary"
	| "websites_requests"
	| "events_list"
	| "mid_request"
	| "clients_terminals"
	| "payment_raw_section"
	| "payment_log_section"
	| "payment_trx_section"
	| "report_sessions"
	| "invites"
	| "api_users"
	| "merchant_settings"
	| "adjustments";
export type TRoles = "admin" | "aml" | "merchant" | "accountant" | "support";
export type TFeature = {
	role: TRoles[];
};
export type TFeaturedComponent<T = any> = React.FC<T> & {
	feature: TAvailableFeatures;
};
export const FeaturesMap: Partial<Record<TAvailableFeatures, TFeature>> = {
	sessions: { role: ["admin", "merchant", "accountant", "support"] },
	overview: { role: ["admin"] },
	credentials: { role: ["admin"] },
	settings: { role: ["admin"] },
	integrations: { role: ["admin"] },
	fees: { role: ["admin"] },
	client_users: { role: ["admin", "support"] },
	client_overview: { role: ["admin"] },
	client_summary: { role: ["admin", "merchant", "accountant", "support"] },
	websites_requests: { role: ["admin"] },
	invites: { role: ["admin"] },
	api_users: { role: ["admin"] },
	mid_request: { role: ["admin"] },
	clients_terminals: { role: ["admin"] },
	payment_raw_section: { role: ["admin"] },
	payment_log_section: { role: ["admin"] },
	payment_trx_section: { role: ["admin"] },
	events_list: { role: ["admin", "support"] },
	report_sessions: { role: ["admin", "merchant", "accountant"] },
	merchant_settings: { role: ["admin", "aml", "merchant"] },
	adjustments: { role: ["admin"] },
};

let project_id = 0;
let project_roles: ProjectRole[] = [];

GD.S_PROJECT_SELECTED.subscribe(p => {
	project_id = p.id;
	project_roles = p.roles;
});

export const checkFeature = (feature: TAvailableFeatures): boolean => {
	const roles = FeaturesMap[feature];

	if (!roles) return false;
	if (!project_roles || !project_roles.length) return false;
	if (!project_id) return false;

	return hasAnyRole(project_roles, roles.role);
};
